import * as React from 'react'
import { AccentButton } from '../controls/AccentButton';
import { accentUtils, t } from '../services/HelperService';
import { AccentDialog } from './AccentDialog'
import { RepSignaturePad, SignaturePad } from './../controls/documents/SignaturePad'
import { isMobileOnly } from '../controls/AccentDisplay';
export const SignatureDlg = React.memo(props => {

    const onClose = props.onClose;
    const repSignature = props.repSignature;
    const imageType = repSignature ? "image/svg+xml" : "image/png";
    const [signatureRefreshKey, setSignatureRefreshKey] = React.useState(1);
    const [signature, setSignature] = React.useState(accentUtils.isEmpty(props.initialSignature) ? null : props.initialSignature);
    const [signerName, setSignerName] = React.useState(props.signer ?? null);
    const [initials, setInitials] = React.useState(null);
    const [signatureStyleId, setSignatureStyleId] = React.useState(null);
    const [signatureChanged, setSignatureChanged] = React.useState(false);

    // SignaturePad calls: onSignatureSave(signature, signerName, initials, signatureStyleId)
    const onSignatureSave = React.useCallback((sig, signer, initials, styleId) => {
        setSignature(sig);
        setSignerName(signer);
        setInitials(initials);
        setSignatureStyleId(styleId);
        setSignatureChanged(true);
    }, []);

    const recapture = React.useCallback(e => {
        setSignature(null);
        setSignatureStyleId(null);
        setSignatureChanged(false);
        setSignatureRefreshKey(k => k + 1);
    }, [setSignature, setSignatureStyleId, setSignatureChanged, setSignatureRefreshKey]);

    const close = React.useCallback(e => {

        onClose({ signature: signature, signer: signerName, initials: initials, signatureStyleId: signatureStyleId });
    },[onClose, signature, signerName, initials, signatureStyleId])


    const allowClose = !accentUtils.isEmpty(signature);
    const showCancel = !accentUtils.isEmpty(signature);
    const actions = !showCancel ? undefined : [
        <AccentButton key="3" tagName="closeBtn" disabled={!allowClose} onClick={recapture}>{t("application_strings.application.buttons.recapture")}</AccentButton>,
        ...(signatureChanged
            ? [<AccentButton key="2" tagName="closeBtn" disabled={!allowClose} onClick={close}>{t("application_strings.application.buttons.ok")}</AccentButton>]
            : [])
    ];

    return <AccentDialog
        fullscreen={isMobileOnly}
        maxWidth={isMobileOnly ? undefined : 600}
        noCancel={ !showCancel}
        headerContent={t(repSignature ? "application_strings.application.dialogs.signature.repTitle" : "application_strings.application.dialogs.signature.title")}
        onClose={onClose}
        actionsContent={actions}
    >
        {repSignature
            ? <RepSignaturePad key={signatureRefreshKey} onSignatureSave={onSignatureSave} readOnly={allowClose} onCancel={e => onClose({ canceled: true })} imageType={imageType} previewSignature={signature} />
            : <SignaturePad key={signatureRefreshKey} onSignatureSave={onSignatureSave} signer={props.signer} readOnly={allowClose} onCancel={e => onClose({ canceled: true })} imageType={imageType} />}
    </AccentDialog >;

});